import { render, staticRenderFns } from "./GroupDeviceSoftware.vue?vue&type=template&id=da91c17c&scoped=true&"
import script from "./GroupDeviceSoftware.vue?vue&type=script&lang=js&"
export * from "./GroupDeviceSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da91c17c",
  null
  
)

export default component.exports